

import { Row, Col, Dialog, Toast, Icon, Lazyload, Notify, Empty } from 'vant'
import error from 'Assets/images/error.png'
import _loading from 'Assets/images/loading/type_1.gif'

// 全局组件注册
const VUX_GLOBAL_COMPONENTS = [
  /** vant */
  Row,
  Col,
  Icon,
  Empty
]

/**
 *需要以plugin形式调用的组件
 * plugin形式: https://doc.vux.li/zh-CN/components/alert.html
 */
const VUX_GLOBAL_PLUGINS = [
  /** vant */
  Toast,
  Dialog,
  Lazyload,
  Notify
]

Dialog.setDefaultOptions({
  closeOnPopstate: true // 是否在页面回退时自动关闭
})

Lazyload.options = {
  error: error,
  loading: _loading,
  attempt: 3  
}

const install = (Vue) => {
  if (install.installed) { return }
  install.installed = true

  VUX_GLOBAL_COMPONENTS.map(component => {
    Vue.component(component.name, component)
    // https://cn.vuejs.org/v2/api/#Vue-component
  })
  VUX_GLOBAL_PLUGINS.map(plugin => {
    Vue.use(plugin, plugin.options || {})
  })
}

export default install
